import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(relativeTime);

export const intToOrdinalNumberString = (num: number): string => {
  num = Math.round(num);
  const numString = num.toString();

  // If the ten's place is 1, the suffix is always "th"
  // (10th, 11th, 12th, 13th, 14th, 111th, 112th, etc.)
  if (Math.floor(num / 10) % 10 === 1) {
    return `${numString}th`;
  }

  // Otherwise, the suffix depends on the one's place as follows
  // (1st, 2nd, 3rd, 4th, 21st, 22nd, etc.)
  switch (num % 10) {
    case 1:
      return `${numString}st`;
    case 2:
      return `${numString}nd`;
    case 3:
      return `${numString}rd`;
    default:
      return `${numString}th`;
  }
};

export const isObjectEmpty = (obj: any) => {
  return Object.keys(obj).length === 0 && obj.constructor === Object;
};

export const getScrollBarWidth = () => {
  return window.innerWidth - document.documentElement.clientWidth;
};

export const getStartingIn = (stringDate: string | undefined) => {
  if (!stringDate) {
    return 'unknown';
  }
  const date = dayjs.utc(stringDate);
  const now = dayjs.utc();

  if (date.isBefore(now)) {
    return `Started ${date.from(now)}`;
  }
  return `Starting ${now.to(date)}`;
};

export const isDateBefore = (stringDate: string | undefined) => {
  if (!stringDate) {
    return false;
  }
  const date = dayjs.utc(stringDate);
  const now = dayjs.utc();

  if (date.isBefore(now)) {
    return true;
  }
  return false;
};

export const sleep = (ms: number) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

export const canStartNewGame = (
  isGameActive: boolean,
  isActiveFieldPresent: boolean,
  isBackfield: boolean,
  isConnectedToRadar: boolean,
  isLoggedIn: boolean,
  updating: boolean
) => {
  if (updating) {
    return false;
  }

  if (!isConnectedToRadar) {
    return false;
  }

  if (isGameActive || !isActiveFieldPresent) {
    return false;
  }

  if (isBackfield && (!isConnectedToRadar || !isLoggedIn)) {
    return false;
  }

  return true;
};
